import { useAppDispatch } from "app/hooks";
import { PrintIcon } from "components/SVGs";
import { printingSet } from "features/Reports";

function PrintReport() {
  const dispatch = useAppDispatch();
  const isNotDisable = true;

  const clickHandler = () => {
    if (isNotDisable) {
      dispatch(printingSet(true));
      setTimeout(() => {
        window.print();
      }, 1000);
      setTimeout(() => {
        dispatch(printingSet(false));
      }, 2000);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: isNotDisable ? "pointer" : "default",
      }}
      onClick={clickHandler}
    >
      <PrintIcon
        sx={{
          color: isNotDisable ? "rgb(77, 191, 241)" : "rgb(77, 191, 241, 0.3)",
        }}
      />
    </div>
  );
}

export default PrintReport;
